// eslint-disable-next-line import/prefer-default-export
export const Fieldset = {
  Image: 'url',
  Name: 'name',
  Width: 'width',
  Height: 'height',
};
